var React = require('react');

function PlusInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"343.03","cy":"343.03","r":"343.03","style":{"fill":"#1d5377"},"key":0}),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},[React.createElement("rect",{"x":"156.61","y":"315.12","width":"372.84","height":"55.81","style":{"fill":"#fff"},"key":0}),React.createElement("rect",{"x":"213.58","y":"372.09","width":"372.84","height":"55.81","transform":"translate(-56.97 743.03) rotate(-90)","style":{"fill":"#fff"},"key":1})])]);
}

PlusInline.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 686.05 686.05"};

module.exports = PlusInline;

PlusInline.default = PlusInline;
